/* eslint-disable no-nested-ternary */
import { useEffect, useState, createRef } from "react";
import PropTypes from "prop-types";
import useImageWrapper from "helpers/hooks/useImageWrapper";
import ButtonImage from "solar/components/ButtonImage";
import Photo from "components/shared/stays/Photo";
import styles from "components/shared/stays/PhotosGrid.module.scss";

export default function PhotosGrid({
  photos,
  photoAlt,
  inPage = false,
  onClick = null,
  prioritizeFirstPhoto = false,
}) {
  const { getImageWidth } = useImageWrapper();
  const [imgWidths, setImgWidths] = useState([0]);
  const imgWrapperRefs = photos.map(() => createRef(null));

  useEffect(() => {
    const calculatedWidth = getImageWidth(imgWrapperRefs);
    setImgWidths(calculatedWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.component}>
      {photos.length > 1 ? (
        <div className={styles.multiple}>
          {photos.slice(0, 2).map((photo, idx) => (
            <div
              key={photo.id}
              className={styles.photo}
              ref={imgWrapperRefs[idx]}
            >
              {onClick && photos.length > 2 ? (
                <ButtonImage onClick={() => onClick(photo.position)}>
                  <Photo
                    src={photo.file.url}
                    alt={photoAlt}
                    layout="fill"
                    objectFit="cover"
                    placeholder
                    containerWidth={imgWidths && imgWidths[idx]}
                    priority={prioritizeFirstPhoto}
                  />
                </ButtonImage>
              ) : onClick && inPage ? (
                <ButtonImage onClick={() => onClick()}>
                  <Photo
                    src={photo.file.url}
                    alt={photoAlt}
                    layout="fill"
                    objectFit="cover"
                    placeholder
                    containerWidth={imgWidths && imgWidths[idx]}
                    priority={prioritizeFirstPhoto}
                  />
                </ButtonImage>
              ) : (
                <Photo
                  src={photo.file.url}
                  alt={photoAlt}
                  layout="fill"
                  objectFit="cover"
                  placeholder
                  containerWidth={imgWidths && imgWidths[idx]}
                />
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.single}>
          <div className={styles.photo}>
            {onClick && inPage ? (
              <ButtonImage onClick={() => onClick()}>
                <Photo
                  src={photos[0].file.url}
                  alt={photoAlt}
                  layout="fill"
                  objectFit="cover"
                  placeholder
                  containerWidth={imgWidths[0]}
                />
              </ButtonImage>
            ) : (
              <Photo
                src={photos[0].file.url}
                alt={photoAlt}
                layout="fill"
                objectFit="cover"
                placeholder
                containerWidth={imgWidths[0]}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

PhotosGrid.propTypes = {
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.shape({
        id: PropTypes.number,
        url: PropTypes.string,
      }),
    })
  ).isRequired,
  photoAlt: PropTypes.string.isRequired,
  inPage: PropTypes.bool,
  onClick: PropTypes.func,
  prioritizeFirstPhoto: PropTypes.bool,
};
